export const brand = {
  legalName: "Better Mortgage Corporation",
  name: "Better.com",
  shortName: "Better",
  phone: "415-523-8837",
}
